import styled from "styled-components";
import { BbotAlert } from "top-component-library";

export const LegacyLinkAlert = styled(BbotAlert)`
  margin-bottom: 15px;
`;

export const SectionHeading = styled.div`
  margin: 40px 0 12px;

  h2 {
    margin-bottom: 4px;
  }
`;

export const UploadControls = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const PreviewCaption = styled.p`
  font-weight: 500;
  margin: 8px 0;
`;

export const BannerPreviewImage = styled.img`
  max-width: 100%;
  max-height: 240px;
  border: 1px solid var(--color-neutral__line);
  border-radius: 4px;
`;

export const LogoPreviewImage = styled.img`
  max-width: 240px;
  max-height: 160px;
  border: 1px solid var(--color-neutral__line);
  border-radius: 4px;
`;

export const SettingControl = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 240px;
`;

export const SettingHeading = styled.h4`
  margin-bottom: 8px;
`;

export const SettingHint = styled.div`
  color: var(--color-neutral__text-secondary);
  font-size: 16px;
`;

export const ReceiptPreview = styled.div`
  line-height: 1.5;
  margin-top: 4px;
  text-align: center;

  > * {
    display: block;
  }
`;

export const SaveRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

export const EditorLabel = styled.p`
  margin-bottom: 8px;
`;

export const QuillWrapper = styled.div`
  .ql-container {
    min-height: 120px;
  }
`;
